export type UserRole = 'admin' | 'superAdmin' | 'operator' | 'owner' | 'noRole';

export enum UserRoleEnum {
  admin = 'admin',
  superAdmin = 'superAdmin',
  operator = 'operator',
  owner = 'owner',
}
